import { MusicGameCharacter } from "GameObjects/MusicGame/Character";

export class MusicGameAmy extends MusicGameCharacter {

    animations = {
        idle: "Idle",
        idleToReady: "Idle to Ready",
        ready: "Ready To Play",
        playing: "Playing V2",
    }

    constructor(pData: {id: number}) {
        super({name: 'amy', skeleton: 'Amy Music Experience', ...pData});
        this.playAnimation(this.animations.idle);
        this._spine.update(0);
    }

}